const typeOptions =
    [
        { value: 'V_HD', label: '🎥HD' },
        { value: 'V_3DV', label: '🎥3DV' },
        { value: 'V_3DH', label: '🎥3DH' },
        { value: 'V_3DHF', label: '🎥3DHF' },
        { value: 'V_3DHD', label: '🎥3DHD' },
        { value: 'V_3DHP', label: '🎥3DHP' },
        { value: 'V_MONO', label: '🎥MONO' },
        { value: '3DGS', label: '🧊3DGS' },
        { value: '4DGS', label: '🧊4DGS' },
        { value: 'MODLE', label: '🧊MODLE' },
        { value: 'IMAGE', label: '🏁Image' },
        { value: 'APP', label: '💻App' }
    ];

export default typeOptions;